import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

/**
 * Public catch-all for unmatched paths. Lives outside the guarded group, so it
 * never triggers an auth redirect.
 */
export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="w-full min-h-[60vh] flex flex-col justify-center items-center gap-4">
      <h1 className="text-4xl font-bold">404</h1>
      <p className="text-lg text-gray-500">{t("pageNotFound")}</p>
      <Link to="/" className="text-mofidBlue-90 underline">
        {t("backToHome")}
      </Link>
    </div>
  );
}
